import { ADD_TODO, TOGGLE_TODO, DELETE_TODO } from "../actionTypes.js";

const initialState = {
  entries: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ADD_TODO: {
      const { id, content } = action.payload;
      return {
        ...state,
        entries: {
          ...state.entries,
          [id]: {
            ...content, 
            id:id
          }
        }
      };
    }
    case TOGGLE_TODO: {
      const { id } = action.payload;
      return {
        ...state,
        entries: {
          ...state.entries,
          [id]: {
            ...state.entries[id],
            value: ++state.entries[id].value
          }
        }
      };
    }
    case  DELETE_TODO:{
      const{id} = action.payload;
      var newentries = Object.assign({},state.entries);
      delete newentries[id];
      return {
        ...state,
        entries: newentries
      };
    }
    default:
      return state;
  }
}
